export enum RepositoriesTypesCookies {
  COOKIES_SAVE_ACCEPTED = '@repositories/COOKIES_SAVE_ACCEPTED',
  COOKIES_DELETE_ACCEPTED = '@repositories/COOKIES_DELETE_ACCEPTED',
}

export interface IRepositoriesStateCookies {
  readonly accepted: boolean;
}
